import React from "react";
import carImg from "../../../images/undraw_city_driver_re_0x5e.svg";
import "./HeaderMain.css";

const HeaderMain = () => {
  return (
    <main className=" frontPart row m-0 mb-5 py-5">
      <div className="col-md-6 frontLine">
        <h5 className="mb-5 py-5 px-5 mt-5">
          ARE YOU HAVING
          <br /> <span className="bestCar">CAR</span> <br />{" "}
          <span className="car">PROBLEMS?</span> <br />{" "}
          <span>
            <h4>Not Anymore! Let's Fix Them</h4>
          </span>
          <small className="small">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid,
            consequatur?
          </small>
        </h5>
      </div>
      <div className="col-md-6">
        <img src={carImg} alt="" width="100%" />
      </div>
    </main>
  );
};

export default HeaderMain;
